export class CreativeTemplate {
  id: number; 
  months: number; 
  gender: string;
  frontImage: string;
  frontCTA: string;
  frontOffer: string;
  frontLogo: string;
  backLogo: string;
  backCTA: string;
  backBackground: string;
  backTopLeftCopy: string;
  backOfferBlock: string;
  backStoreBlock: string;
  backBottomLeftCopy: string;
  style: string;
  brandId: number; 
  campaignTypeId: number;
  ageRangeId: number;
  campaignTypeName: string;
  brandName: string;
  ageRangeName: string;
  //custom1: string;
  //custom2: string;
  //custom3: string;
  //custom4: string;
  //custom5: string;
}
